export const nowQuickLists = [
  {
    name: 'Home pharmacy',
    description: 'Everyday care essentials',
    path: '/category/medicines?from=now',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/225752e9-ff4d-42c2-9ed4-f596feca44f3.jpg',
  },
  {
    name: 'Family wellness',
    description: 'Vitamins for the routine',
    path: '/category/vitamins-supplements?from=now',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/7c15dbf2-c7b9-4fd4-9612-28112ec7c2b8.jpg',
  },
  {
    name: 'Baby essentials',
    description: 'Care for little ones',
    path: '/category/baby-mother-care?from=now',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/e27c3344-f0eb-4d45-98e1-7548944ab240.jpg',
  },
] as const

export const nowPopularSearches = ['Panadol', 'Vitamin D', 'Sunscreen', 'Baby formula', 'Face wash'] as const

export const nowLimitedTimeDeal = {
  eyebrow: 'ENDS TODAY',
  title: 'Everyday care, better value',
  description: 'Save on selected pharmacy essentials with NOW 120 delivery.',
  action: 'Shop limited-time deals',
  path: '/offers?from=now',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/ddb0076b-cd8e-4206-ba68-96a424f9563a.jpg',
} as const

export const nowSpecialtyStores = [
  {
    slug: 'wellness',
    name: 'Wellness store',
    description: 'Vitamins, daily energy, and essentials for healthier routines.',
    categorySlug: 'vitamins-supplements',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/7c15dbf2-c7b9-4fd4-9612-28112ec7c2b8.jpg',
  },
  {
    slug: 'skin-care',
    name: 'Skin care store',
    description: 'Dermatology-led favourites for simple, consistent care.',
    categorySlug: 'beauty-skin-care',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/7d01da99-d99e-47be-873c-dd4767e477dd.jpg',
  },
  {
    slug: 'baby-care',
    name: 'Baby care store',
    description: 'Trusted everyday essentials for little ones and parents.',
    categorySlug: 'baby-mother-care',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/e27c3344-f0eb-4d45-98e1-7548944ab240.jpg',
  },
  {
    slug: 'travel-care',
    name: 'Travel care store',
    description: 'Compact care essentials for every journey.',
    categorySlug: 'personal-care',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/c7bd6f6e-ad46-4d48-b3c1-93277b798a5f.jpg',
  },
] as const
